<template>
    <div class="app-container">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">小微驿站</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/xwqyczfw/wmcxyl' }">文明诚信引领</el-breadcrumb-item>
                    <el-breadcrumb-item>{{dictFormatTitle()}}详情</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.wmcxglTitle}}</h1>
            <el-row class="soure">
                <span style="padding-right: 15px;">发布时间：{{ parseTime(detail.wmcxglFbtime, '{y}-{m}-{d}') }}</span><span style="padding-right: 15px;">访问量：{{browseCount}}</span><span>来源：{{fbDept}}</span>
            </el-row>
            <div v-html="detail.wmcxglContent" class="eidt-content"></div>
<!--            <div style="align-content: center" align="center"><img src="../../../../assets/images/file_tmp/wmcx_tzgg_detail.png" style="width: 1000px"></img></div>-->
        </el-row>

    </div>
</template>

<script>
    import { getBrowseCount } from "@/api/basedata/records";
    import {
        getWmcxgl,
    } from "@/api/xwqy/wmcxgl";
    export default {
        name: "detail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid:undefined,
                type:undefined,
                detail:{},
                browseCount:10,
                menulist:[
                    {code:'tzgg',title:'文明诚信引领工作通知',icon:'el-icon-reading'},
                    {code:'hb',title:'文明诚信红榜',icon:'el-icon-reading'},
                    {code:'cxgs',title:'撤销公示',icon:'el-icon-reading'}
                ],
                fbDept: '威海市市场监督管理局',
                ywViews:{
                    busRecid:undefined,
                    busTableName:'yw_xwqy_wmcxgl',
                },
            }
        },
        created() {
            this.type = this.$route.params && this.$route.params.type;
            this.recid = this.$route.params && this.$route.params.recid;
            this.getDetail();
        },
        methods: {
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getDetail();
            },
            getDetail(){
                const recid = this.recid;
                getWmcxgl(recid).then(response => {
                    this.detail = response.data;
                    this.getBrowseData();
                });
            },
            getBrowseData(){
                this.ywViews.busRecid= this.recid;
                getBrowseCount(this.ywViews).then(response => {
                    this.browseCount=response;
                })
            },
            dictFormatTitle() {
                let that=this;
                let title='';
                Object.keys(that.menulist).map((key) => {
                    if (that.menulist[key].code == that.type) {
                        title=that.menulist[key].title;
                        return false;
                    }
                })
                return title;
            }
        }
    }
</script>

<style scoped>
    .app-container{
        padding:0px 15px 20px;
        background-color: #ffffff;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .content{
        border: 1px solid #cccccc;
        padding:20px 80px;
    }
    .soure{
        background-color:#f3f3f3;
        padding:10px;
        margin: 25px 0;
    }
</style>